<template>
  <div class="app-container app-page">
    <div class="app-header">
      <van-nav-bar :title="$t('my.my_statement')" class="app-nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
      <div class="app-info">
        <p class="app-title">{{$t("withdraw.task_money")}}({{$t("reservation.unit")}})</p>
        <p class="app-value">{{ this.win_money.toFixed(2) }}{{ $t("reservation.unit") }}</p>
        <p class="app-tip">{{$t("reservation.win_formula")}}</p>
      </div>
      <div class="app-content">
        <div class="personal-report-page__datalist">
          <div class="personal-report-page__data-list-item">
            <div class="personal-report-page__datalistitem-value">{{ this.personalreport.play_money }}{{ $t("reservation.unit") }}</div>
            <div class="personal-report-page__datalistitem-key">{{$t("withdraw.task_money")}}</div>
            <div class="datalistitemRightLine"></div>
          </div>
          <div class="personal-report-page__data-list-item">
            <div class="personal-report-page__datalistitem-value">{{ this.personalreport.recharge}}{{ $t("reservation.unit") }}</div>
            <div class="personal-report-page__datalistitem-key">{{$t("withdraw.recharge_money")}}</div>
            <div class="datalistitemRightLine"></div>
          </div>
          <div class="personal-report-page__data-list-item">
            <div class="personal-report-page__datalistitem-value">{{ this.personalreport.withdrawal }}{{ $t("reservation.unit") }}</div>
            <div class="personal-report-page__datalistitem-key">{{$t("withdraw.with_money")}}</div>
            <div class="datalistitemRightLine"></div>
          </div>
          <div class="personal-report-page__data-list-item">
            <div class="personal-report-page__datalistitem-value">{{ this.personalreport.win_money }}{{ $t("reservation.unit") }}</div>
            <div class="personal-report-page__datalistitem-key">{{$t("withdraw.win_money")}}</div>
            <div class="datalistitemRightLine"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      win_money:0,
      personalreport:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getPersonalreport(){
      this.$http({
        method: 'get',
        url: 'user_get_personalreport'
      }).then(res=>{
        if(res.code === 200){
          this.personalreport = res.data;
          this.win_money = this.personalreport.win_money - this.personalreport.play_money;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/auth/login'})
    }else {
      this.getPersonalreport();
    }
  }
};
</script>

<style lang='less' scoped src="./Personalreport.styles.less"></style>
